import React from 'react';

export default function MobileDownloadLink({ source }) {
  return <a className="mobile-download" href={`/download?source=mobile-${source}`}>
    Download KACHNG <span aria-hidden="true">↗</span>
  </a>;
}
